<template>
  <body class="sidebar-body">
    <img
      class="image"
      src="../../assets/sidebar-x-icon.svg"
      alt="x-icon"
      @click="$emit('close')"
    />
    <div class="sidebar">
      <div class="sidebar-content">
        <div
          class="text-wrapper"
          v-for="(item, index) in menuItems"
          :key="index"
          @click="toggleDropdown(index)"
        >
          <div class="text">
            {{ item.name }}
            <Dropdown
              v-if="item.isOpen && item.subItems.length"
              :items="item.subItems"
              @navigate="handleNavigation"
            />
          </div>
          <img
            class="arrow"
            :src="
              item.isOpen
                ? require('../../assets/up-arrow.svg') + '?v=1'
                : require('../../assets/down-arrow.svg') + '?v=1'
            "
            alt="toggle"
          />
        </div>
        <a href="https://www.wecobi.com/">
          <div class="text">Platform</div>
        </a>
      </div>
      <div class="button">Get Started</div>
    </div>
  </body>
</template>

<script>
import Dropdown from "./Dropdown.vue";
import { nextTick } from "vue";

export default {
  name: "Sidebar",
  components: {
    Dropdown,
  },
  data() {
    return {
      menuItems: [
        {
          name: "For Brands",
          isOpen: false,
          subItems: [
            { label: "Optimized Discounts", link: "#optimizedDiscounts" },
            { label: "Extending Lifecycles", link: "#extendingLifecycle" },
            { label: "AB testing", link: "#abtesting" },
            { label: "Overview", link: "#overview" },
          ],
        },
        {
          name: "Sustainability",
          isOpen: false,
          subItems: [
            { label: "Our Mission", link: "/sustainability#mission" },
            {
              label: "Environmental Impact",
              link: "/sustainability#environmentalImpact",
            },
            {
              label: "Decoupled Growth",
              link: "/sustainability#decoupledGrowth",
            },
            { label: "Win-Win-Win Energy", link: "/sustainability#winEnergy" },
          ],
        },
        {
          name: "Company",
          isOpen: false,
          subItems: [
            { label: "About Us", link: "/company#aboutUs" },
            { label: "Partner Program", link: "/company#partnerProgram" },
            { label: "Careers", link: "/careers" },
            { label: "Investor Relations", link: "/company#investorRelations" },
          ],
        },
      ],
    };
  },
  methods: {
    toggleDropdown(index) {
      this.menuItems[index].isOpen = !this.menuItems[index].isOpen;
    },
    handleNavigation(link) {
      if (link.startsWith("#")) {
        if (this.$route.path === "/") {
          this.scrollToHash(link);
        } else {
          this.navigateAndScrollToHash("/", link);
        }
      } else if (link.includes("/sustainability")) {
        const hash = this.getValidHash(link, "/sustainability");
        if (this.$route.path === "/sustainability") {
          this.scrollToHash(hash);
        } else {
          this.navigateAndScrollToHash("/sustainability", hash);
        }
      } else if (link.includes("/company")) {
        const hash = this.getValidHash(link, "/company");
        if (this.$route.path === "/company") {
          this.scrollToHash(hash);
        } else {
          this.navigateAndScrollToHash("/company", hash);
        }
      } else {
        this.$router.push(link);
      }
      this.$emit("close");
    },
    getValidHash(link, path) {
      const hash = link.replace(path, "");
      return hash.startsWith("#") ? hash : `#${hash}`;
    },
    scrollToHash(hash) {
      const validHash = hash.startsWith("#") ? hash : `#${hash}`;

      nextTick(() => {
        const element = document.querySelector(validHash);
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${validHash} not found!`);
        }
      });
    },
    navigateAndScrollToHash(page, hash) {
      this.$router.push({ path: page }).then(() => {
        nextTick(() => {
          setTimeout(() => {
            this.scrollToHash(hash);
          }, 100);
        });
      });
    },
  },
};
</script>

<style scoped>
.sidebar-body {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}

.sidebar-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.2;
  z-index: 1;
}
.sidebar {
  position: relative;
  z-index: 2;
  width: 430px;
  height: 100%;
  padding: 90px 46px 47px 46px;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 2;
}
.sidebar-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.text-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
}

.text {
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  color: #000000;
}
.button {
  width: 100%;
  height: 40px;
  border: 2px solid #000000;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  margin: 16px 20px 0px 0px;
  cursor: pointer;
}
.arrow {
  margin-top: 5px;
}
</style>
